export * from './customer-technical-list.component'